import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Screens
import Products from "./components/screens/Products";
import SingleProduct from "./components/screens/SingleProduct";
import NotFound from "./components/screens/NotFound";

const App = () => {
  return (
    <Router>
      <div className="app">
        <Switch>
          
          <Route exact path="/">
            <Products />
          </Route>
          <Route exact path='/product/:slug'>
            <SingleProduct />
          </Route>
          <Route exact path='*' component={NotFound} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
